import React from 'react';
import { motion } from 'framer-motion';

export default function Header() {
  return (
    <motion.header 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="sticky top-0 w-full z-40 bg-[#0D0D0D]/90 backdrop-blur-md will-change-opacity"
    >
      <div className="w-full px-6 py-5 flex justify-between items-center">
        {/* Left-Side Brand */}
        <div className="flex items-center select-none cursor-pointer">
          <span className="text-white font-[400] text-xl tracking-tight">studio</span>
          <span className="text-white font-[700] text-xl tracking-tight">timer</span>
        </div>

        {/* Right-Side Utility */}
        <nav>
          <a 
            href="https://web.studiotimer.app/#/login" 
            className="text-[#D4D4D8] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple text-sm font-normal"
          >
            Login
          </a>
        </nav>
      </div>
    </motion.header>
  );
}